import CommentsDrawer from "./comments-drawer";

export default CommentsDrawer;